import * as React from "react";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { Box, Typography, Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid2";

import PinOutlinedIcon from "@mui/icons-material/PinOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { AnyForNow } from "../../features/grn/types";

interface GrnSupplierDetailsProps {
  hideTitle?: boolean;
  supplier: AnyForNow;
}

const GrnSupplierDetails: React.FC<GrnSupplierDetailsProps> = (props) => {
  const { hideTitle, supplier } = props;
  const theme = useTheme();
  const styles = useStyles(theme);

  // Tooltip configuration to ensure it appears above the sidebar/popup (z-index: 99999)
  const tooltipPopperProps = {
    style: { zIndex: 100000 },
    modifiers: [
      {
        name: "preventOverflow",
        options: {
          boundary: "viewport",
        },
      },
    ],
  };

  if (!supplier) {
    return <Typography sx={{ p: 2 }}>No supplier selected</Typography>;
  }

  return (
    <>
      <Box sx={styles.grn_supplier_container}>
        {/* <Divider /> */}
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }} sx={styles.grn_supplier_det_grid}>
            <Tooltip 
              title="Supplier Code" 
              arrow
              PopperProps={tooltipPopperProps}
            >
              <PinOutlinedIcon sx={styles.supplier_icons} />
            </Tooltip>
            :
            <Typography sx={styles.grn_supplier_title}>
              {supplier.optSupplierRefCode}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12 }} sx={styles.grn_supplier_det_grid}>
            <Tooltip 
              title="Supplier Name" 
              arrow
              PopperProps={tooltipPopperProps}
            >
              <PersonOutlineOutlinedIcon sx={styles.supplier_icons} />
            </Tooltip>
            :
            <Typography sx={styles.grn_supplier_title}>
              {supplier.optSupplierName}
            </Typography>
          </Grid>

          <Grid size={{ xs: 12 }} sx={styles.grn_supplier_det_grid}>
            <Tooltip 
              title="Contact/Phone" 
              arrow
              PopperProps={tooltipPopperProps}
            >
              <CallOutlinedIcon sx={styles.supplier_icons} />
            </Tooltip>
            :
            <Typography sx={styles.grn_supplier_title}>
              {supplier.contactNo || "N/A"}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12 }} sx={styles.grn_supplier_det_grid}>
            <Tooltip 
              title="Email" 
              arrow
              PopperProps={tooltipPopperProps}
            >
              <EmailOutlinedIcon sx={styles.supplier_icons} />
            </Tooltip>
            :
            <Typography sx={styles.grn_supplier_title}>
              {supplier.email || "N/A"}
            </Typography>
          </Grid>
        <Grid
          size={{ xs: 12 }}
          sx={{
            ...styles.grn_supplier_det_grid,
            display: "flex",
            alignItems: "flex-start", 
            borderRight: "none",
          }}
        >
          <Tooltip 
            title="Supplier Address" 
            arrow
            PopperProps={tooltipPopperProps}
          >
            <BusinessOutlinedIcon sx={{ ...styles.supplier_icons, mt: "2px" }} /> 
          </Tooltip>
          :
          <Typography sx={{ ...styles.grn_supplier_title, ml: 1 }}>
            {supplier.optSupplieraddressline1} <br />
            {supplier.optSupplieraddressline2} <br />
            {supplier.optSupplieraddressline3}
          </Typography>
        </Grid>

        </Grid>
      </Box>
    </>
  );
};

export default GrnSupplierDetails;
